<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
@if (isOpen()) {
<sml-dialog [size]="'xl'" [isOpen]="isOpen()" (closed)="close()" class="!tw-z-[10000]"
  [showCloseButtonOnMobile]="false"
  [customDialogBodySpacing]="'!tw-p-0 max-md:!tw-max-h-full max-md:!tw-overflow-hidden'"
  [modalBodyClass]="'max-md:!tw-h-full'"
  modalClass="max-md:!tw-h-full max-md:!tw-w-full max-md:!tw-max-w-full max-md:!tw-m-0 max-md:!tw-items-stretch md:!tw-delay-0"
  [bodyClass]="'max-md:!tw-h-full max-md:!tw-rounded-none'">

  <div class="tw-flex tw-flex-col max-md:tw-h-full max-md:tw-overflow-hidden">

    <!-- Header -->
    <div
      class="tw-flex tw-items-center tw-gap-2 tw-px-4 tablet:tw-px-5 tw-py-3.5 tw-border-b tw-border-solid tw-border-mercury-200">
      <i-icon [name]="'image'" class="!tw-w-[18px] !tw-h-[18px] tw-shrink-0 tw-text-primary-700"></i-icon>
      <span class="tw-text-grey-950 tw-text-[15px] tw-leading-5 tw-font-bold">{{ strings.TITLE }}</span>
      <button type="button" aria-label="Close" (click)="close()"
        class="tw-ml-auto tw-shrink-0 tw-w-[25px] tw-h-[25px] tw-rounded-full tw-border tw-border-solid tw-border-mercury-200 tw-bg-transparent tw-flex tw-items-center tw-justify-center tw-text-mercury-600 hover:tw-text-grey-950 hover:tw-border-primary-200">
        <i-icon [name]="'x-mark'" class="!tw-w-[11px] !tw-h-[11px]"></i-icon>
      </button>
    </div>

    <!-- Search -->
    <div class="tw-flex tw-flex-col tw-gap-2.5 tw-px-4 tablet:tw-px-5 tw-pt-3 tw-pb-2.5">
      <div class="tw-flex tw-items-center tw-gap-2">
        <div
          class="tw-flex tw-flex-1 tw-items-center tw-gap-2 tw-h-[38px] tw-border tw-border-solid tw-border-mercury-200 tw-rounded-[9px] tw-px-3 tw-bg-grey-50">
          <i-icon [name]="'search'" class="!tw-w-[15px] !tw-h-[15px] tw-shrink-0 tw-text-mercury-600"></i-icon>
          <input type="text" [(ngModel)]="searchTerm" (keyup.enter)="search()" [disabled]="!isConfigured"
            [placeholder]="strings.SEARCH_PLACEHOLDER" aria-label="Search photos"
            class="tw-w-full tw-border-0 tw-outline-none tw-bg-transparent tw-text-[13.5px] tw-text-grey-950 placeholder:tw-text-mercury-600" />
        </div>
        <button type="button" [disabled]="!isConfigured || !searchTerm.trim() || isSearching()" (click)="search()"
          class="tw-shrink-0 tw-inline-flex tw-items-center tw-justify-center tw-h-[38px] tw-px-[18px] tw-rounded-[9px] tw-border-0 tw-bg-primary-700 tw-text-white tw-text-[13px] tw-font-bold tw-whitespace-nowrap tw-transition-colors hover:tw-bg-primary-800 disabled:tw-opacity-45 disabled:tw-cursor-not-allowed">
          {{ strings.SEARCH_BUTTON }}
        </button>
      </div>

      <div class="tw-flex tw-items-start tw-gap-[7px]">
        <span class="tw-shrink-0 tw-text-[11.5px] tw-text-mercury-600 tw-mr-0.5 tw-pt-1.5">{{ strings.SUGGESTED_LABEL
          }}</span>
        <div
          class="sml-tag-track tw-flex tw-items-center tw-gap-[7px] tw-min-w-0 tw-flex-1 tw-overflow-x-auto tw-pb-1.5">
          @for (keyword of suggestedKeywords(); track keyword) {
          <button type="button" (click)="searchKeyword(keyword)" [disabled]="!isConfigured"
            class="tw-shrink-0 tw-whitespace-nowrap tw-text-xs tw-font-semibold tw-border tw-border-solid tw-border-primary-200 tw-rounded-full tw-px-[13px] tw-py-1.5 tw-transition-colors hover:tw-border-primary-700 disabled:tw-opacity-50"
            [ngClass]="isKeywordActive(keyword) ? 'tw-bg-primary-100 tw-text-primary-700' : 'tw-bg-transparent tw-text-mercury-950'">
            {{ keyword }}
          </button>
          }
        </div>
      </div>

      @if (errorMessage()) {
      <div class="tw-flex tw-items-center tw-gap-2 tw-bg-[#FDF3F3] tw-rounded-lg tw-px-3 tw-py-2">
        <i-icon [name]="'warning_o'" class="!tw-w-4 !tw-h-4 tw-shrink-0"></i-icon>
        <span class="tw-text-xs tw-text-alert-900">{{ errorMessage() }}</span>
      </div>
      }
    </div>

    <!-- Results -->
    <div
      class="tw-px-4 tablet:tw-px-5 tw-pt-3.5 tw-pb-4 tw-border-t tw-border-solid tw-border-mercury-200 tw-min-h-[300px] tw-max-h-[480px] tw-overflow-y-auto max-md:tw-flex-1 max-md:tw-min-h-0 max-md:tw-max-h-none">

      @if (!isConfigured) {
      <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-h-[300px] max-md:tw-h-full tw-text-center">
        <i-icon [name]="'warning_o'" class="!tw-w-12 !tw-h-12 tw-text-mercury-200"></i-icon>
        <span class="tw-text-base tw-font-bold tw-text-grey-850">{{ strings.UNAVAILABLE_TITLE }}</span>
        <span class="tw-text-sm tw-text-mercury-600 tw-max-w-[360px]">{{ notConfiguredMessage }}</span>
      </div>
      }
      @else if (isLoadingFirstResults()) {
      <div class="tw-h-[300px] max-md:tw-h-full"></div>
      }
      @else if (isSearching()) {
      <div class="tw-flex tw-items-center tw-justify-center tw-h-[300px] max-md:tw-h-full">
        <sml-spinner [type]="'spinner'" [isGlobal]="false" [size]="'md'" [loaderClass]="''"></sml-spinner>
      </div>
      }
      @else if (!hasSearched()) {
      <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-h-[300px] max-md:tw-h-full tw-text-center">
        <i-icon [name]="'camera'" class="!tw-w-16 !tw-h-16 tw-text-mercury-200"></i-icon>
        <span class="tw-text-base tw-font-bold tw-text-grey-850">{{ strings.START_TITLE }}</span>
        <span class="tw-text-sm tw-text-mercury-600 tw-max-w-[360px]">{{ strings.START_MESSAGE }}</span>
      </div>
      }
      @else if (!images().length) {
      <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-h-[300px] max-md:tw-h-full tw-text-center">
        <i-icon [name]="'search'" class="!tw-w-12 !tw-h-12 tw-text-mercury-200"></i-icon>
        <span class="tw-text-base tw-font-bold tw-text-grey-850">{{ strings.EMPTY_TITLE }}</span>
        <span class="tw-text-sm tw-text-mercury-600 tw-max-w-[360px]">{{ strings.EMPTY_MESSAGE }}</span>
      </div>
      }
      @else {

      <!-- Selection line -->
      <div class="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-mb-2.5">
        <span class="tw-text-xs tw-font-semibold tw-text-mercury-600">
          {{ selectionHint() }} &mdash;
          <b class="tw-text-primary-700 tw-tabular-nums">{{ selectedCount() }}</b>
          {{ strings.SELECTED_SUFFIX }}
        </span>
        @if (hasSelection()) {
        <button type="button" (click)="clearSelection()"
          class="tw-shrink-0 tw-bg-transparent tw-border-0 tw-p-0 tw-text-xs tw-font-bold tw-text-primary-700 hover:tw-underline">
          {{ strings.CLEAR_SELECTION }}
        </button>
        }
      </div>

      <div class="tw-grid tw-gap-3 {{ tileGridClass() }}">
        @for (image of images(); track image.id) {
        <div
          class="tw-relative tw-rounded-[11px] tw-overflow-hidden tw-cursor-pointer {{ tileShapeClass() }}"
          role="button" [attr.aria-pressed]="isSelected(image)"
          [attr.aria-label]="image.description || 'Stock photo'" (click)="toggleSelection(image)"
          (keyup.enter)="toggleSelection(image)">
          <img [src]="tileUrl(image)" [alt]="image.description || 'Stock photo'" loading="lazy"
            (error)="onImageFailed(image)" class="tw-w-full tw-h-full tw-object-cover" />

          <!-- Bottom scrim, so the caption and the two badges stay readable on pale photos -->
          <div
            class="tw-absolute tw-inset-0 tw-pointer-events-none tw-bg-gradient-to-t tw-from-[rgba(4,10,12,.78)] tw-to-transparent tw-to-55%">
          </div>

          @if (isSelected(image)) {
          <div
            class="tw-absolute tw-inset-0 tw-pointer-events-none tw-rounded-[11px] tw-border-[3px] tw-border-solid tw-border-primary-700">
          </div>
          }

          <!-- Selection tick -->
          <div
            class="tw-absolute tw-top-[7px] tw-left-[7px] tw-w-[21px] tw-h-[21px] tw-rounded-full tw-border-[1.5px] tw-border-solid tw-flex tw-items-center tw-justify-center tw-transition-colors"
            [ngClass]="isSelected(image)
              ? 'tw-bg-primary-700 tw-border-primary-700'
              : 'tw-bg-[rgba(4,10,12,.35)] tw-border-white/85'">
            @if (isSelected(image)) {
            <i-icon [name]="'tick_o'" class="tw-text-white"></i-icon>
            }
          </div>

          <button type="button" [attr.aria-label]="strings.PREVIEW" (click)="openPreview(image, $event)"
            class="tw-absolute tw-top-[7px] tw-right-[7px] tw-w-[21px] tw-h-[21px] tw-rounded-full tw-bg-[rgba(4,10,12,.45)] hover:tw-bg-[rgba(4,10,12,.75)] tw-border-0 tw-outline-none tw-flex tw-items-center tw-justify-center tw-transition-colors">
            <i-icon [name]="'preview-icon'" class="!tw-w-[11px] !tw-h-[11px] !tw-text-white"></i-icon>
          </button>

          @if (image.description) {
          <div
            class="tw-absolute tw-left-2 tw-right-2 tw-bottom-[7px] tw-pointer-events-none tw-text-white tw-text-[10.5px] tw-font-semibold tw-leading-[1.25] tw-line-clamp-2">
            {{ image.description }}
          </div>
          }
        </div>
        }
      </div>

      @if (hasMore()) {
      <div class="tw-flex tw-justify-center tw-pt-4">
        <button type="button" [disabled]="isLoadingMore()" (click)="loadMore()"
          class="tw-inline-flex tw-items-center tw-justify-center tw-gap-1.5 tw-h-[38px] tw-px-4 tw-rounded-lg tw-border tw-border-solid tw-border-primary-200 tw-bg-primary-100 tw-text-primary-700 tw-text-[13.5px] tw-font-bold tw-whitespace-nowrap tw-transition-colors hover:tw-border-primary-700 disabled:tw-opacity-45 disabled:tw-cursor-not-allowed">
          {{ isLoadingMore() ? '' : strings.LOAD_MORE }}
          @if (isLoadingMore()) {
          <sml-spinner [type]="'spinner'" [isGlobal]="false" [size]="'sm'" [loaderClass]="''"></sml-spinner>
          }
        </button>
      </div>
      }
      }
    </div>
  </div>

  <!-- Footer -->
  <div footer
    class="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-flex-wrap tw-px-4 tablet:tw-px-5 tw-py-3.5 tw-border-t tw-border-solid tw-border-mercury-200">
    @if (requiresAttribution) {
    <span class="tw-text-[11.5px] tw-text-mercury-600">
      {{ strings.PHOTOS_PROVIDED_BY }}
      @if (attributionUrl) {
      <a [href]="attributionUrl" target="_blank" rel="noopener noreferrer"
        class="tw-font-bold tw-text-mercury-950 tw-no-underline tw-border-b tw-border-solid tw-border-primary-200 hover:tw-text-primary-700">
        {{ providerName }}
      </a>
      } @else {
      <span class="tw-font-bold tw-text-mercury-950">{{ providerName }}</span>
      }
    </span>
    }
    <div class="tw-flex tw-items-center tw-gap-4 tw-ml-auto">
      @if (isAdding()) {
      <span class="tw-text-xs tw-text-mercury-600">{{ strings.ADDING }}</span>
      }
      <button type="button" (click)="close()"
        class="tw-inline-flex tw-items-center tw-justify-center tw-h-8 tw-px-3 tw-rounded-lg tw-border tw-border-solid tw-border-mercury-200 tw-bg-transparent tw-text-mercury-950 tw-text-[12.5px] tw-font-bold tw-whitespace-nowrap tw-transition-colors hover:tw-border-primary-200">
        {{ strings.CANCEL }}
      </button>
      <button type="button" [disabled]="!canAdd()" (click)="addSelected()"
        class="tw-inline-flex tw-items-center tw-justify-center tw-h-8 tw-px-3 tw-rounded-lg tw-border tw-border-solid tw-border-primary-700 tw-bg-primary-700 tw-text-white tw-text-[12.5px] tw-font-bold tw-whitespace-nowrap tw-transition-colors hover:tw-bg-primary-800 disabled:tw-opacity-45 disabled:tw-cursor-not-allowed">
        {{ addButtonLabel() }}
      </button>
    </div>
  </div>

</sml-dialog>
}

@if (isOpen()) {
@if (previewImage(); as preview) {
<div class="tw-fixed tw-inset-0 tw-z-[10001] tw-flex tw-items-center tw-justify-center tw-p-4 tw-bg-black/80"
  (click)="closePreview()">
  <div
    class="tw-relative tw-flex tw-flex-col tw-gap-3 tw-w-full tw-bg-white tw-rounded-2xl tw-p-4 {{ previewPanelWidthClass() }}"
    (click)="$event.stopPropagation()">

    <div
      class="tw-relative tw-w-full tw-rounded-xl tw-bg-grey-250 tw-overflow-hidden tw-flex tw-items-center tw-justify-center"
      [ngClass]="previewFrameRatio() ? 'tw-max-h-[56vh]' : 'tw-h-[min(56vh,420px)]'"
      [style.aspect-ratio]="previewFrameRatio()">
      <img [src]="previewUrlFor(preview)" [alt]="preview.description || 'Stock photo preview'"
        (load)="onPreviewLoaded()" (error)="onImageFailed(preview)"
        class="tw-max-w-full tw-max-h-full tw-object-contain tw-transition-opacity tw-duration-200"
        [ngClass]="previewLoaded() ? 'tw-opacity-100' : 'tw-opacity-0'" />
      @if (!previewLoaded()) {
      <div class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
        <sml-spinner [type]="'spinner'" [isGlobal]="false" [size]="'md'" [loaderClass]="''"></sml-spinner>
      </div>
      }
    </div>

    <div class="tw-flex tw-items-end tw-justify-between tw-gap-3 tw-flex-wrap">
      <div class="tw-flex tw-flex-col tw-gap-1 tw-min-w-0 tw-flex-1 tw-basis-[240px]">
        @if (preview.description) {
        <span class="tw-text-[13px] tw-font-bold tw-text-grey-950 tw-line-clamp-2">{{ preview.description }}</span>
        }
        <span class="tw-text-[11.5px] tw-text-mercury-600">
          {{ strings.PHOTO_BY }}
          @if (preview.photographerUrl) {
          <a [href]="preview.photographerUrl" target="_blank" rel="noopener noreferrer"
            class="tw-text-mercury-950 tw-font-semibold tw-underline">{{ preview.photographerName }}</a>
          } @else {
          {{ preview.photographerName }}
          }
          {{ strings.ON_PROVIDER }}
          @if (preview.providerUrl) {
          <a [href]="preview.providerUrl" target="_blank" rel="noopener noreferrer"
            class="tw-text-mercury-950 tw-font-semibold tw-underline">{{ providerName }}</a>
          } @else {
          {{ providerName }}
          }
        </span>
      </div>

      <!-- Same toggle the tiles use, so picking here and picking in the grid stay in step -->
      <button type="button" (click)="toggleSelectionFromPreview(preview)" [attr.aria-pressed]="isSelected(preview)"
        class="tw-shrink-0 tw-ml-auto tw-flex tw-items-center tw-gap-1.5 tw-h-[34px] tw-px-4 tw-rounded-lg tw-text-[13px] tw-font-bold tw-border tw-border-solid tw-transition-colors"
        [ngClass]="isSelected(preview)
          ? 'tw-bg-primary-100 tw-text-primary-700 tw-border-primary-200'
          : 'tw-bg-primary-700 tw-text-white tw-border-primary-700 hover:tw-bg-primary-800'">
        @if (isSelected(preview)) {
        <i-icon [name]="'tick_o'" class="!tw-w-[13px] !tw-h-[13px]"></i-icon>
        }
        {{ isSelected(preview) ? strings.PREVIEW_ADDED : strings.PREVIEW_ADD }}
      </button>
    </div>

    <button type="button" [attr.aria-label]="strings.CLOSE_PREVIEW" (click)="closePreview()"
      class="tw-absolute -tw-top-3 -tw-right-3 tw-w-8 tw-h-8 tw-rounded-full tw-bg-white tw-border tw-border-solid tw-border-mercury-200 tw-shadow-md tw-flex tw-items-center tw-justify-center tw-text-mercury-950 hover:tw-text-grey-950 hover:tw-border-primary-200">
      <i-icon [name]="'x-mark'" class="!tw-w-3.5 !tw-h-3.5"></i-icon>
    </button>
  </div>
</div>
}
}

@if (isAdding() || isLoadingFirstResults()) {
<sml-spinner [type]="'dots'" [isGlobal]="true" [wrapperClass]="'!tw-z-[10002]'"></sml-spinner>
}
